import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { RouteService } from 'src/app/shared/services/route.service';

export interface pago{
  pagoId: string;
  pagoTotal: number;
  instructorFechaPago: any;
  instructorNombre: string;
  instructorId: string;
  instructorViaPago: string;
  instructorEstatusPago: string;
}

@Component({
  selector: 'pagos',
  templateUrl: './pagos.component.html',
  styleUrls: ['./pagos.component.css']
})
export class PagosComponent implements OnInit {

  id = this.route.snapshot.paramMap.get('id');
  instructorNombre: string;
  pagos: pago[] = [];

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
    public routeService: RouteService
  ) {

   }

  ngOnInit(): void {
    if (this.id == null) {
      this.cargarTodoLosPagos();
    } else {
      this.cargarPagosInstructor();
    }
  }

  cargarPagosInstructor() {
    this.afs.collection('instructoresPagos').ref.where('instructorId', "==", this.id).get().then(response => {
      response.docs.forEach(doc => {
        const data = doc.data();
        const pago: pago = {
          pagoId: doc.id,
          pagoTotal: data["pagoTotal"],
          instructorFechaPago: data["instructorFechaPago"],
          instructorNombre: data["instructorNombre"],
          instructorId: data["instructorId"],
          instructorViaPago: data["instructorViaPago"],
          instructorEstatusPago: data["instructorEstatusPago"]
        }
        this.instructorNombre = pago.instructorNombre;
        this.pagos = this.pagos.concat(pago);
        this.pagos.sort((a,b) => +b.instructorFechaPago - +a.instructorFechaPago)
      })
    })
  }

  cargarTodoLosPagos() {
    this.afs.collection('instructoresPagos').ref.get().then(response => {
      response.docs.forEach(doc => {
        const data = doc.data();
        const pago: pago = {
          pagoId: doc.id,
          pagoTotal: data["pagoTotal"],
          instructorFechaPago: data["instructorFechaPago"],
          instructorNombre: data["instructorNombre"],
          instructorId: data["instructorId"],
          instructorViaPago: data["instructorViaPago"],
          instructorEstatusPago: data["instructorEstatusPago"],
        }
        this.pagos = this.pagos.concat(pago);
        this.pagos.sort((a,b) => +b.instructorFechaPago - +a.instructorFechaPago)
      })
    })
  }
}
